<template lang="html">
  <div>
    <div>

  <table class="table table-hover table-sm col-md-11" ref="assets" :data="assets">
  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Assets 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Description</th>
      <th class="text-center" scope="col">Amount</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(asset, index) in assets" v-bind:key="index" >
          <td class="text-center">
            {{asset.desc}}
          </td>
          <td class="text-center">
            {{asset.amount}}
          </td>
        </tr>
  </tbody>
  </table>
  </div>

  <form v-on:submit.prevent="addasset">
<div class="form-row">
    <div class="form-group col-md-3">
    
      <input type="text" class="form-control" id="description" placeholder="Description" v-model="desc">
    </div>
    <div class="form-group col-md-3">
      <input type="text" class="form-control" id="amount" placeholder="Amount" v-model="amount">
    </div>
    <div class="form-group col-md-3">
      <button type="submit" class="btn btn-primary">Add Asset</button>
    </div>
</div>
</form>

  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');

export default {
  name: 'assets',
  data () {
    return {
      assets: [],
      desc : null,
      amount : null
    }
  },
  methods: {
addasset(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('assets').add({
 
    desc: this.desc,
    amount: parseFloat(this.amount)
  }).then(ref => {
  const data = {
    'id' : ref.id,
    desc: this.desc,
    amount: '$' + parseFloat(this.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  this.assets.push(data)
  this.desc = ''
  this.amount = ''
})
}
  },
  created (){  
    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('assets').get().then
  (querySnapshot => {
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'desc' : doc.data().desc,
        'amount' : '$' + parseFloat(doc.data().amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
      this.assets.push(data)
      //console.log(data)
    })
  }
  )
  }
}
</script>